import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=33336cd2&"
import script from "./Files.vue?vue&type=script&lang=js&"
export * from "./Files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33336cd2')) {
      api.createRecord('33336cd2', component.options)
    } else {
      api.reload('33336cd2', component.options)
    }
    module.hot.accept("./Files.vue?vue&type=template&id=33336cd2&", function () {
      api.rerender('33336cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Files.vue"
export default component.exports